export default __webpack_public_path__ + "static/plan-your-trip-994c63e629639ede7f241f93bdcfca6f.webp";